import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { find } from 'lodash';
import { combineLatest, Observable } from 'rxjs';
import { flatMap, map, publishReplay, refCount } from 'rxjs/operators';
import { UrlBuilder } from '../core/url-builder/url-builder';
import { CategoriesStorage, Category, TabCategory } from '../documents';
import { DocumentsTabsCategoriesComponentBase } from '../investigator/base/document-tabs-categories-component-base';
import { routeParams } from '../shared/route-helpers';

@Component({
    selector: 'general-documents-tabs-categories',
    template: require('./general-documents-tabs.component.html'),
    styles: [require('./general-documents-tabs.component.scss')],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class GeneralDocumentsTabsComponent extends DocumentsTabsCategoriesComponentBase {
    public categoryName: Observable<string>;

    public queryParams: Observable<Params>;

    constructor(
        private route: ActivatedRoute,
        urlBuilder: UrlBuilder,
        private categoriesStorage: CategoriesStorage
    ) {
        super(urlBuilder);

        this.queryParams = route.queryParams;
    }

    protected createTabsCategories(): Observable<TabCategory[]> {
        const categoryId = this.route.params.pipe(map(x => x[routeParams.categoryId] as string | undefined));

        this.categoryName = categoryId
            .pipe(
                flatMap(x =>
                    this.categoriesStorage.generalCategories.pipe(map(generalCategories => {
                            return find(generalCategories, category => category.categoryId === x);
                        })
                    )),
                map(x => x ? x.name : null)
            );

        const tabsCategories = combineLatest(
                this.categoriesStorage.generalCategories,
                categoryId
            )
            .pipe(
                map(([generalCategories, categoryIdValue]) => {
                    const generalCategory = find(generalCategories, c => c.categoryId === categoryIdValue);

                    if (!generalCategory) {
                        return [];
                    }

                    const tabs = this.createGeneralTabs(generalCategory, generalCategory.children);

                    return tabs;
                }),
                publishReplay(1),
                refCount()
            );

        return tabsCategories;
    }

    private createGeneralTabs(category: Category, childGeneralCategories: Category[]): TabCategory[] {
        const tabs = childGeneralCategories.map(generalCategory => {
            const url = this.urlBuilder
                .esa()
                .globalPopup()
                .generalDocuments(category)
                .category(generalCategory)
                .url();

            return { name: generalCategory.name, url } as TabCategory;
        });

        return tabs;
    }
}